export const TOOLTIP_DESCRIPTION = `Any payments made for business software or cloud computing services that facilitated your business operations,
    products or service delivery, the processing, payment, or tracking of payroll expenses,
    human resources, sales and billing functions, or the accounting of supplies, inventory, records and expenses.`;

export const TOOLTIP_NAME = 'coveredOperationsExpendituresTooltip';
